import s from './ScreenLoading.module.css'

/**
 * Полноэкранное ожидание. Роутер показывает его, пока идёт `beforeLoad` — то есть пока
 * `shellRoute` ждёт `GET /me`.
 *
 * Без него холодный старт БЕЗ СЕТИ давал **белую страницу**. Не «загрузка», не ошибка —
 * пустоту: `networkMode: 'online'` не отклоняет запрос, а СТАВИТ ЕГО НА ПАУЗУ, и промис
 * `beforeLoad` висит бессрочно, пока сеть не вернётся. Роутеру нечего было отрисовать.
 *
 * Оффлайн-баннер при этом виден — он смонтирован вне роутера (`App.tsx`), — так что человек
 * увидит «нет соединения» поверх этого экрана и поймёт, чего ждёт.
 *
 * Показывается не сразу: `defaultPendingMs: 200` в конфиге роутера. Быстрый ответ не мигнёт.
 */
export function ScreenLoading() {
  return (
    <div className={s.root} role="status" aria-live="polite">
      <span className={s.logo} aria-hidden="true">
        P
      </span>
      <span className={s.label}>Загружаем…</span>
    </div>
  )
}
